<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ tag.id ? 'Edit' : 'Create' }} Tag</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit(form)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Tag</mat-label>
      <input
        matInput
        placeholder="Tag"
        [(ngModel)]="tag.title"
        name="title"
        type="text"
        required
        #title />
      <mat-hint>Please enter a Tag title.</mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        rows="4"
        matInput
        placeholder="Description"
        [(ngModel)]="tag.description"
        name="description"
        #description>
      </textarea>
      <mat-hint>Please enter a short description for the tag.</mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">

    <!-- Hidden when the user cannot perform the action (create for a new tag, edit for an existing
         one). Remains disabled only for form validity and in-flight state. -->
    <button
      *ngIf="tag.id ? canEdit : canCreate"
      class="my-2 ml-1 mr-2"
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      id="save">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      *ngIf="canDelete"
      type="button"
      color="warn"
      mat-icon-button
      [disabled]="!tag.id"
      class="dialog-remove-button my-2 ml-auto mr-1"
      (click)="onDelete()"
      matTooltip="Archive Tag">
      <mat-icon>archive</mat-icon>
    </button>

  </mat-dialog-actions>

</form>
